<template lang="pug">
transition(name="fade", mode="out-in", appear)
  v-app(v-if="$auth.ready()", key="app")
    Sidebar(v-if="$auth.check()", style="z-index: 2")
    v-main(style="z-index: 1")
      template(v-if="!dialogsHidden")
        Quiz
        OnboardingCompany
        OnboardingCase
        Messages
        EmployeeDialog
        OnboardingCandidate
      div(:class="[$route.name !== 'Login' && 'pa-4']")
        Viewer(v-model="docsShown", :docs="docs", hasSign)
        .toolbar.d-flex.align-center(v-if="$auth.check()")
          transition(name="fade", mode="out-in", appear)
            h1(:key="$route.meta.title", v-text="$route.meta.title")
          v-spacer
          v-icon mdi-bell-outline
        transition(name="fade", mode="out-in", appear)
          router-view(:key="$route.meta.title")
  v-overlay(v-else, key="overlay", absolute, :opacity="0")
    v-progress-circular(:size="64", color="#50bdc1", indeterminate)
</template>

<script>
import Quiz from "@/components/Quiz";
import Sidebar from "@/components/Sidebar";
import Messages from "@/components/Messages";
import Viewer from "@/components/Documents/Viewer.vue";
import EmployeeDialog from "@/components/Employee/GlobalDialogs/index.vue";
import OnboardingCompany from "@/components/Onboarding/Company/index.vue";
import OnboardingCase from "@/components/Onboarding/Case/index.vue";
import OnboardingCandidate from "@/components/Onboarding/Candidate/index.vue";

export default {
  name: "App",

  components: {
    Sidebar,
    Messages,
    Viewer,
    EmployeeDialog,
    OnboardingCompany,
    OnboardingCase,
    OnboardingCandidate,
    Quiz
  },

  data: () => ({
    dialogsHidden: false,
    docs: [
      {
        Name: "Contract.docx",
        ID: 1,
      },
    ],
  }),

  computed: {
    docsShown() {
      return this.$store.state.viewDoc !== null;
    },
  },

  watch: {
    "$route.name": {
      handler: function (v) {
        this.dialogsHidden = v === "Login";
      },
    },
  },
};
</script>

<style lang="sass">
.fade
  &-enter-active, &-leave-active
    transition: opacity .3s
  &-enter, &-leave-to
    opacity: 0

.v-overlay, .v-dialog__content
  left: 256px
  right: 0
  width: auto

.v-data-table

  th, td
    white-space: nowrap

  td
    max-width: 300px
    overflow: hidden
    text-overflow: ellipsis

.v-dialog
  max-width: calc(90vw - 256px)

.theme--light
  &.v-application, .v-card > .v-card__text
    color: #000000 !important
</style>
